import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BooksDialogComponent } from '../books-dialog/books-dialog.component';
import { UnlockChapterDialogComponent } from '../unlock-chapter-dialog/unlock-chapter-dialog.component';

@Component({
  selector: 'app-self-learn-subject',
  templateUrl: './self-learn-subject.component.html',
  styleUrls: ['./self-learn-subject.component.css']
})
export class SelfLearnSubjectComponent implements OnInit {

  subjectName: string;
  chapterViewMoreStatus:boolean = false;
  headerBannerdata = [
    {
      bannerTitle: '',
      chapterCount: 0,
      progress: 0,
      subjectIcon: ''
    }
  ];
  chapTemp:any = [];
  chapterdata:any = [];
  isUserSubscribed:boolean;
  coins:any
  freeChaptersCount:any;
  subjectId:any;
  bookId:any = 0;
  booksData: any;
  isLoading:boolean;
  bookName: any;
  resumeVideoData: any;
  subjectData:any;
  chapterIds:any = [];
  constructor(public router: Router, 
    public spinner:NgxSpinnerService, 
    private dialog: MatDialog,
    public selfLearnService:SelfLearnService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.getResumeVideoForSubject();
    localStorage.removeItem('currentChapterTabIndex');
    this.subjectId = localStorage.getItem("selfLearnSelectedSubject");
    let bookID:any = localStorage.getItem('selctedBookId');
    if(bookID){
      this.bookId = bookID;
      this.bookName  = localStorage.getItem('selctedBookName');  
      this.getChaptersForExamAndSubject(this.subjectId);
      if(this.selfLearnService.isFromLearn()){
        this.getCoinsDetails();
        this.checkForSubscription()}
    }else{
      this.getBooksForSubjects();
    }
  

  }
  getBooksForSubjects(){
    //this.spinner.show();
    this.selfLearnService.getBooksAndAssetCount(this.subjectId).subscribe((res:any) => {
     this.booksData= res.data;
     if(res.status){
      //this.spinner.show();
      if(this.booksData.books.length <=1){
        if(this.booksData.books.length==1){
          this.bookId = this.booksData.books[0].id;
          this.bookName =this.booksData.books[0].name;
          localStorage.setItem('selctedBookName',this.bookName);
            
        }else{
          this.bookId  =0;
        }
        this.getChaptersForExamAndSubject(this.subjectId);
        if(this.selfLearnService.isFromLearn()){
          this.getCoinsDetails();
          this.checkForSubscription()}else{}
          
      }else{
        this.openBooksDialog();
       }
     }else{
      console.log('error');
     }
    })
  }

  getChaptersForExamAndSubject(subjectId:any){
    this.spinner.show();
    this.selfLearnService.getChaptersForExamAndSubject(subjectId,this.bookId).subscribe((resp) => {
      this.spinner.hide();
      this.subjectName = resp.data.parent.subjectName;
      this.subjectData = {
        nodeName:resp.data.parent.subjectName
      }
      this.headerBannerdata[0].subjectIcon = resp.data.parent.icon
      this.getChapterProgress(subjectId);
      console.log(resp);
    })
  }

  getChapterProgress(subjectId:any){
    this.spinner.show();
    this.selfLearnService.getChapterProgress(subjectId,this.bookId).subscribe((resp:any) => {
      this.spinner.hide();
      if(resp == null) return;
      this.chapterdata = resp.chapters.filter((currentItem) => currentItem.topicsCount > 0);
      this.headerBannerdata[0].chapterCount = this.chapterdata.length;
      this.freeChaptersCount = resp.freeChaptersCount;
      this.headerBannerdata[0].progress = Number((resp?.subjectProgress).toPrecision(2));
      this.chapterdata.map((chapter:any) => {
        this.chapterIds.push(chapter.chapterId)
      })
      this.isLoading= false;
    });
    console.log( this.chapterdata);
  }

  chapterViewMore(){
    this.chapterViewMoreStatus = !this.chapterViewMoreStatus;
  }

  navigateTOChapterPage(chapter:any){
    if(!this.selfLearnService.isFromLearn()){this.redirectToChapterPage(chapter); return}
    if(this.isUserSubscribed || chapter.unlockStatus){this.redirectToChapterPage(chapter)}
    else if((this.checkForChapterUnlockStatus() < this.freeChaptersCount)){
      const payload = this.constructJsonForUnlockAndRedeem(chapter,'freeCount');
      this.openChapterUnlockDialog(chapter,'freeCount', payload);
    }
    else{
      const type = (this.checkIfEligible(chapter)) ? 'isCoinsToRedeem' : 'isToSubcribe'
      const payload = this.constructJsonForUnlockAndRedeem(chapter, type);
      this.openChapterUnlockDialog(chapter, type, payload);}
  }

  saveCoinsSummary(chapter:any){
    const payload = this.constructJsonForsaveCoinsSummary(chapter);
      this.selfLearnService.saveRedeemSummary(payload).subscribe((resp: any) => {
    });
  }

  constructJsonForsaveCoinsSummary(chapter:any){
    const payload = {
      coins: chapter?.redeemCoinsCount,
      days: 0,
      discountApplied: false,
      name: 'unlock_chapter',
      percentage: 0,
      userId: this.selfLearnService.getUserInfo().userId,
    };
  }

  checkIfEligible(chapter:any){
    return ((this.coins - chapter.redeemCoinsCount) > 0) ? true : false;
  }

  getCoinsDetails(){
    this.selfLearnService.getCoinsDetails().subscribe((resp:any) => {
      this.coins = resp?.totActiveCoins;
    });
  }

  checkForChapterUnlockStatus(){
    const freeCount =  this.chapterdata.filter((currentItem) => currentItem.unlockStatus == true).length;
    return freeCount;
  }

  constructJsonForUnlockAndRedeem(chapter:any, type:any){
    const payload = {
      "examId": this.selfLearnService.getCmsExamID(),
      "gradeId": this.selfLearnService.getGradeId(),
      "subjectId": this.selfLearnService.getSubjectId(),
      "chapterId": chapter.chapterId,
      "chapterName": chapter.chapterName,
      "packageId": 0,
      "isUnlocked": true,
      "chapterIds":this.chapterIds,
      "coins": type == 'freeCount' ? 0 : this.getRedeemCoins(chapter)
    };
    return payload;
  }

  getRedeemCoins(chapter:any) {
    return (this.checkForChapterUnlockStatus() < this.freeChaptersCount) ? 0 : chapter.redeemCoinsCount;
  }

  redirectToChapterPage(chapter:any){
    localStorage.setItem("chapterId", chapter.chapterId);
    localStorage.setItem("chapterName", chapter.chapterName);
    this.router.navigateByUrl("selfLearn-V2/chapter");
  }

  checkForSubscription(){
    const payload = {
      gradeno: this.selfLearnService.getGradeId(),
      product_Type: "selflearn",
      uam_exam_id: this.selfLearnService.getUAMExamIdForLearn(),
      userId: this.selfLearnService.getUserInfo().userId,
    }
    this.selfLearnService.checkSubscriptions(payload).subscribe((resp:any) => {
      this.isUserSubscribed = resp.subscribed;
    });
  }

  openChapterUnlockDialog(chapter:any , popupType:string='', payload?:any) {
    const config: MatDialogConfig = {
      width: '375px',
      panelClass: ['SLV2-unlock-chapter-modal'],
      disableClose: true,
      data: {payload : payload, type : popupType, freeCount : this.freeChaptersCount - this.checkForChapterUnlockStatus(),
         checkIfEligible : this.checkIfEligible(chapter), coins : this.coins, chapter : chapter},
    };
    this.dialog.open(UnlockChapterDialogComponent, config);
  }

  openBooksDialog() {
    const dialogRef  = this.dialog.open(BooksDialogComponent, { width: '768px', panelClass: 'SLV2-books-dialog',data:this.booksData ,disableClose: true });
    dialogRef.afterClosed().subscribe((value) => {
      if(value){
      localStorage.setItem('selctedBookId',value);
      this.bookId = value;
      let book:any;
      book = this.booksData.books.filter((book:any) => book.id  == this.bookId)
      this.bookName = book[0].name;
      localStorage.setItem('selctedBookName',book[0].name);
      this.getChaptersForExamAndSubject(this.subjectId);
      if(this.selfLearnService.isFromLearn()){
        this.getCoinsDetails();
        this.checkForSubscription()}
      }
    });
  }

  getResumeVideoForSubject(){
    this.selfLearnService.getResumeVideoForSubject().subscribe((res:any) =>{
      console.log(res);
      this.resumeVideoData = res[0];
    })
  }
}
